<div class="trending-searches" *ngIf="loaded && terms.length">
  <span class="trending-searches-title">{{ title }}</span>
  <div class="trending-searches-chips">
    <button
      type="button"
      class="trending-chip"
      *ngFor="let t of terms"
      (click)="onTermClick(t.term)"
      [attr.title]="t.term"
    >
      <span
        *ngIf="t.hasClicks"
        class="material-symbols-outlined trending-chip-icon"
        aria-hidden="true"
      >trending_up</span>
      <span class="trending-chip-label">{{ t.term }}</span>
    </button>
  </div>
</div>
